import { Stack, Typography } from "@mui/material"
import type { FC } from ".."
import filmFestivalGlobals from "./assets/filmFestivalGlobals.json"

const TermsAndConditions: FC = () => {
  const { descriptionItems } = filmFestivalGlobals.drawerContent.terms
  return (
    <Stack gap={4}>
      {descriptionItems.map((item) => (
        <Typography
          key={item}
          variant="body.md"
          sx={(theme) => ({
            fontSize: "16px !important",
            lineHeight: "140% !important",
          })}
        >
          {item}
        </Typography>
      ))}
    </Stack>
  )
}

export default TermsAndConditions
